<script>
import button from '../mixins/button';
import iconImg from '../images/zoom-in.png';

export default {
    name: 'ZoomIn',
    mixins: [button],
    data() {
        return {
            name: 'Zoom In',
            icon: 'el-icon-zoom-in',
            toolTipText: {
                // 工具提示
                zh: '放大', // 中文
                en: 'Zoom In', // 英文
            },
            iconImage: iconImg,
            iconImageActive: iconImg,
            color: {
                enabled: '#1d212d',
                active: '#2e7df8',
                disabled: 'gray',
            },
            styles: {
                // fontSize: '24px',
            },
        };
    },
    methods: {
        execute() {
            this.$parent.zoomIn();
        },
    },
};
</script>
